import { useEffect, useState } from "react";
import { Button, Input, Modal, ModalBody, ModalFooter } from "reactstrap";


let subscriber = null

function subscribe(fn) {
  subscriber = { fn }
}

function unsubscribe() {
  subscriber = null
}

export function confirm(config, onConfirm) {
  if (!subscriber) return

  if (typeof config == 'string') {
    subscriber.fn({
      header: 'Confirmação',
      text: config,
      onConfirm
    })
    return
  }

  subscriber.fn(config)
}


export default function Confirmation() {
  const [config, setConfig] = useState()
  const [inputValue, setInputValue] = useState('')
  const [inputError, setInputError] = useState(false)

  useEffect(() => {
    subscribe(setConfig)
    return () => {
      unsubscribe()
    }
  })

  useEffect(() => {
    setInputValue(config?.inputDefaultValue || '')
    setInputError(false)
  }, [config])

  const handleClose = () => {
    config.onClose && config.onClose()
    setConfig()
  }

  const handleConfirm = () => {
    const inputRequired = !!config?.inputRequired
    const normalizedInputValue = (inputValue || '').trim()

    if (inputRequired && !normalizedInputValue) {
      setInputError(true)
      return
    }

    config.onConfirm && config.onConfirm({ inputValue: normalizedInputValue })
    setConfig()
  }
  
  const handleRefuse = () => {
    config.onRefuse && config.onRefuse()
    setConfig()
  }

  return (
    <Modal isOpen={config} >
      {config && (
        <>
          <div className="modal-header d-flex justify-content-center">
            <h3 className="modal-title" id="exampleModalLabel">
              {config.header}
            </h3>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={handleClose}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <ModalBody>
              {(!!config.icon || !!config.text) && (
                <div className="d-flex align-items-center justify-content-center">
                  {!!config.icon && (<i className={`bi ${config.icon} mr-3`} style={{ fontSize: '2rem' }} />)}
                  {!!config.text && <span>{config.text}</span>}
                </div>
              )}
            {!!config.showInput && (
              <div className="mt-3">
                <label htmlFor="confirmation-input" className="mb-1">
                  {config.inputLabel || 'Justificativa'}
                  {config.inputRequired ? ' *' : ''}
                </label>
                <Input
                  id="confirmation-input"
                  type={config.inputType || 'textarea'}
                  rows={config.inputRows || 4}
                  value={inputValue}
                  onChange={ev => {
                    setInputValue(ev.target.value)
                    if (inputError) setInputError(false)
                  }}
                  placeholder={config.inputPlaceholder || ''}
                />
                {inputError && (
                  <small className="text-danger">
                    {config.inputRequiredMessage || 'Este campo é obrigatório.'}
                  </small>
                )}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={handleRefuse} >{config.refuseButtonText || 'Não'}</Button>
            <Button type="button" color="danger" onClick={handleConfirm} >{config.confirmButtonText || 'Sim'}</Button>
          </ModalFooter>
        </>
      )}
    </Modal>
  )
}